module.exports = __webpack_public_path__ + "img/register_pc_03.954b61ad.png";